export default __webpack_public_path__ + "static/media/arrow-right.1cd99b4f.svg";